import { reactive } from "vue";
export const focusStore = reactive({
    selectedObject: null,
    bookPageItemControl: null,
    mainBookPageItemControl: null,
    focusBookPage: null,

    isFocusToolBar: false,
    isFocusPaintBoard: false,
    isFocusToolBox: false,
    isFocusQuickDirectory: false,
    mainBookPage: null,

    getSelectedObject() {
        return this.selectedObject;
    },
    setSelectedObject(object) {
        this.selectedObject = object;
    },
    getNowPageItemControl() {
        return (this.bookPageItemControl) ? this.bookPageItemControl : this.mainBookPageItemControl;
    },
    setNowPageItemControl(bookPageItemControl = null, type = "") {
        if (bookPageItemControl == null) {
            this.bookPageItemControl = null;
            return;
        }
        this.bookPageItemControl = {
            type: type,
            itemControl: bookPageItemControl
        };
    },
    setMainPageItemControl(bookPageItemControl = null) {
        this.mainBookPageItemControl = {
            type: "mainPage",
            itemControl: bookPageItemControl
        }
    },
    setFocusToolBar(isFocusToolBar) {
        this.isFocusToolBar = isFocusToolBar;
    },
    setFocusPaintBoard(isFocusPaintBoard) {
        this.isFocusPaintBoard = isFocusPaintBoard;
    },
    setFocusToolBox(isFocusToolBox) {
        this.isFocusToolBox = isFocusToolBox;
    },
    setFocusQuickDirectory(isFocusQuickDirectory) {
        this.isFocusQuickDirectory = isFocusQuickDirectory;
    },
    setFocusBookPage(bookPage) {
        this.focusBookPage = bookPage;
        this.setCurrentPageItemControl(bookPage);
    },
    setMainBookPage(bookPage) {
        this.mainBookPage = bookPage;
        this.setCurrentPageItemControl(bookPage);
    },
    setCurrentPageItemControl(bookPage) {
        window.currentPageItemControl = bookPage.pageItemControl;
    },
    setEmptyPageItemControl(type) {
        const emptyControl = {
            bookItems: []
        }
        this.setNowPageItemControl(emptyControl, type);
    }
});